import {AppTester} from "../../supporting";

export const getShouldDisplaySearch = (activeTab?: string) => {
    const isDaMuseum = AppTester.isDaMuseum();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isSuperPuper = AppTester.isSuperPuper();
    const isDvaDesign = AppTester.isDvaDesign();
    const isBrnd = AppTester.isBrnd();
    const isOnlines = AppTester.isOnlines();
    const isCompetition = AppTester.isCompetition();
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isMonaLisaTravels = AppTester.isMonaLisaTravels();

    if (isBooksGallllery) {
        return activeTab === 'menu';
    }

    return (
        !isDaMuseum
        && !isAgeytomesh
        && !isSuperPuper
        && !isDvaDesign
        && !isBrnd
        && !isOnlines
        && !isCompetition
        && !isGalllleryArt
        && !isMonaLisaTravels)
}import {AppTester} from "../../supporting";

export const getShouldDisplaySearch = (activeTab?: string) => {
    const isDaMuseum = AppTester.isDaMuseum();
    const isAgeytomesh = AppTester.isAgeytomesh();
    const isSuperPuper = AppTester.isSuperPuper();
    const isDvaDesign = AppTester.isDvaDesign();
    const isBrnd = AppTester.isBrnd();
    const isOnlines = AppTester.isOnlines();
    const isCompetition = AppTester.isCompetition();
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isBooksGallllery = AppTester.isBooksGallllery();
    const isMonaLisaTravels = AppTester.isMonaLisaTravels();

    if (isBooksGallllery) {
        return activeTab === 'menu';
    }

    return (
        !isDaMuseum
        && !isAgeytomesh
        && !isSuperPuper
        && !isDvaDesign
        && !isBrnd
        && !isOnlines
        && !isCompetition
        && !isGalllleryArt
        && !isMonaLisaTravels)
}